import { AxiosResponse } from 'axios';
import {
  RemoteExecutionServiceImpl,
  RemotePOSTCallInputObject,
  ServerResponse,
} from '../../remoteExecution/RemoteExecutionServiceImpl';
import { AgencyObjClient } from '../agency-data/AgencyInterfaces';
import {
  JobberWorkerTypeStatus,
} from '../../common/CommonInterfaces';

interface UpdateJobberWorkerTypeStatusRequestDTO {
  readonly workerTypeUniqueIdentifier: string;
  readonly status: JobberWorkerTypeStatus;
}

const backendApiBasePathLocal = process.env.REACT_APP_BACK_END_SERVER_BASE_PATH_LOCAL;
const remoteCallObject = RemoteExecutionServiceImpl();

const UpdateJobberWorkerTypeStatusAPICall = async (
  updateRequest: UpdateJobberWorkerTypeStatusRequestDTO
): Promise<AgencyObjClient | null> => {
  const postCallInput: RemotePOSTCallInputObject<UpdateJobberWorkerTypeStatusRequestDTO> = {
    apiUrl: `${backendApiBasePathLocal}agency/actions/update-jobber-worker-type-status`,
    headers: {},
    object: updateRequest,
  };

  try {
    const apiResponse: AxiosResponse<ServerResponse<AgencyObjClient, Error>> =
      await remoteCallObject.remotePOSTCallV2<
        ServerResponse<AgencyObjClient, Error>,
        UpdateJobberWorkerTypeStatusRequestDTO
      >(postCallInput);

    if (apiResponse && apiResponse.data && apiResponse.data.data) {
      return apiResponse.data.data;
    }
    return null;
  } catch (error) {
    console.error('Error updating jobber worker type status:', error);
    throw error;
  }
};

export {
  UpdateJobberWorkerTypeStatusAPICall,
  UpdateJobberWorkerTypeStatusRequestDTO,
};
